import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load das páginas
const Home = lazy(() => import('../pages/Home'));
const CadastroInicial = lazy(() => import('../pages/CadastroInicial'));
const SelecionarCorDia = lazy(() => import('../pages/SelecionarCorDia'));
const PreenchimentoRespostas = lazy(() => import('../pages/PreenchimentoRespostas'));
const NotasOficiais = lazy(() => import('../pages/NotasOficiais'));

export const enemGabarito2025Routes: RouteObject[] = [
  {
    path: '/enem-gabarito-2025',
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'cadastro',
        element: <CadastroInicial />,
      },
      {
        path: 'selecionar-cor/:dia',
        element: <SelecionarCorDia />,
      },
      {
        path: 'preencher',
        element: <PreenchimentoRespostas />,
      },
      {
        path: 'notas-oficiais',
        element: <NotasOficiais />,
      },
    ],
  },
];
